import React, { useEffect } from 'react';

import { getContact } from '../api/contacts';
import { getUserFullName } from '../components/helpers/functions';

import Slider from '../components/Shell/Slider';
import LoadingSkeleton from '../components/Shell/LoadingSkeleton';

import useAsync from '../hooks/useAsync';
import useModal from '../hooks/useModal';

const NAME = 'viewProfile';

const getTitle = ({ type, title, company, location } = {}) => {
	if (type === 'person') {
		if (company && title) {
			return `${title} at ${company.companyName}`;
		} else if (company && !title) {
			return `from ${company.companyName}`;
		} else if (!company && title) {
			return title;
		}
	} else if (type === 'company') {
		return `${location && ` from ${location}`}`;
	}
	return null;
};

export default () => {
	const { open, setClose } = useModal(NAME);
	const {
		value: profile,
		execute: getProfile,
		status,
		resetValue,
	} = useAsync(getContact, {
		immediate: false,
	});

	useEffect(() => {
		if (open?.profile?.id) {
			getProfile({ id: open?.profile?.id });
		}
	}, [open]);

	const isLoading = !profile || status === 'pending';

	return (
		<Slider name={NAME} onClose={() => resetValue()}>
			{isLoading ? (
				<LoadingSkeleton />
			) : (
				<div>
					<div className="pb-1 sm:pb-6">
						<div>
							<div className="mt-6 px-4 sm:mt-8 sm:flex sm:items-end sm:px-6">
								<div className="sm:flex-1">
									<div>
										<div className="flex items-center">
											<h3 className="text-xl font-bold text-gray-900 sm:text-2xl">
												{open?.profile?.companyName ||
													getUserFullName(open?.profile)}
											</h3>
										</div>
										<p className="text-sm text-gray-500">
											{getTitle(open?.profile)}
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="px-4 pt-5 pb-5 sm:px-0 sm:pt-0">
						<div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-6">
							<dl className="grid grid-cols-1 gap-x-4 gap-y-4">
								{[
									{ field: 'Email', dataIndex: 'email' },

									{
										field: 'Phone',
										dataIndex: 'phoneNumber',
									},
									{ field: 'Location', dataIndex: 'location' },
								]
									.filter(({ dataIndex }) => profile[dataIndex])
									.map(({ field, dataIndex }) => (
										<div key={field} className="sm:col-span-1">
											<dt className="text-sm font-medium text-gray-500">
												{field}
											</dt>
											<dd className="mt-1 text-sm text-gray-900">
												{profile[dataIndex]}
											</dd>
										</div>
									))}
							</dl>
						</div>

						{/* Team member list */}
						{profile?.team?.length ? (
							<div className="mt-5 mx-auto max-w-5xl px-4 sm:px-6 lg:px-6">
								<h2 className="text-sm font-medium text-gray-500 mb-3">
									{profile?.type === 'company'
										? `Team members`
										: `Team members at ${profile?.company?.companyName}`}
								</h2>
								<div className="mt-1 grid grid-cols-1 gap-4">
									{profile?.team?.map((person) => (
										<div
											key={person.id}
											className="relative flex items-center space-x-3 rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm focus-within:ring-2 focus-within:ring-pink-500 focus-within:ring-offset-2"
										>
											<div className="min-w-0 flex-1">
												<div className="focus:outline-none">
													<span
														className="absolute inset-0"
														aria-hidden="true"
													/>
													<p className="text-sm font-medium text-gray-900">
														{getUserFullName(profile)}
													</p>
													<p className="truncate text-sm text-gray-500">
														{getTitle(profile)}
													</p>
												</div>
											</div>
										</div>
									))}
								</div>
							</div>
						) : null}
					</div>
				</div>
			)}
		</Slider>
	);
};

const PROFILE = () => {
	/*
<Transition.Root show={openSlider} as={Fragment}>
    <Dialog
        as="div"
        className="relative z-10 xl:hidden"
        onClose={() => setOpenSlider(false)}
    >
        <div className="fixed inset-0" />

        <div className="fixed inset-0 overflow-hidden">
            <div className="absolute inset-0 overflow-hidden">
                <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
                    <Transition.Child
                        as={Fragment}
                        enter="transform transition ease-in-out duration-500 sm:duration-700"
                        enterFrom="translate-x-full"
                        enterTo="translate-x-0"
                        leave="transform transition ease-in-out duration-500 sm:duration-700"
                        leaveFrom="translate-x-0"
                        leaveTo="translate-x-full"
                    >
                        <Dialog.Panel className="pointer-events-auto w-screen max-w-md">
                            <div className="flex h-full flex-col overflow-y-scroll bg-white shadow-xl">
                                <div className="px-4 py-6 sm:px-6">
                                    <div className="flex items-start justify-between">
                                        <h2
                                            id="slide-over-heading"
                                            className="text-lg font-medium text-gray-900"
                                        >
                                            Profile
                                        </h2>
                                        <div className="ml-3 flex h-7 items-center">
                                            <button
                                                type="button"
                                                className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:ring-2 focus:ring-indigo-500"
                                                onClick={() => setOpenSlider(false)}
                                            >
                                                <span className="sr-only">Close panel</span>
                                                <XMarkIcon
                                                    className="h-6 w-6"
                                                    aria-hidden="true"
                                                />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="pb-1 sm:pb-6">
                                        <div>
                                            <div className="relative h-40 sm:h-56">
                                                <img
                                                    className="absolute h-full w-full object-cover"
                                                    src="https://images.unsplash.com/photo-1501031170107-cfd33f0cbdcc?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&h=600&q=80"
                                                    alt=""
                                                />
                                            </div>
                                            <div className="mt-6 px-4 sm:mt-8 sm:flex sm:items-end sm:px-6">
                                                <div className="sm:flex-1">
                                                    <div>
                                                        <div className="flex items-center">
                                                            <h3 className="text-xl font-bold text-gray-900 sm:text-2xl">
                                                                Ashley Porter
                                                            </h3>
                                                            <span className="ml-2.5 inline-block h-2 w-2 flex-shrink-0 rounded-full bg-green-400">
                                                                <span className="sr-only">Online</span>
                                                            </span>
                                                        </div>
                                                        <p className="text-sm text-gray-500">
                                                            @ashleyporter
                                                        </p>
                                                    </div>
                                                    <div className="mt-5 flex flex-wrap space-y-3 sm:space-y-0 sm:space-x-3">
                                                        <button
                                                            type="button"
                                                            className="inline-flex w-full flex-shrink-0 items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:flex-1"
                                                        >
                                                            Message
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="inline-flex w-full flex-1 items-center justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                                        >
                                                            Call
                                                        </button>
                                                        <div className="ml-3 inline-flex sm:ml-0">
                                                            <Menu
                                                                as="div"
                                                                className="relative inline-block text-left"
                                                            >
                                                                <Menu.Button className="inline-flex items-center rounded-md border border-gray-300 bg-white p-2 text-sm font-medium text-gray-400 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
                                                                    <span className="sr-only">
                                                                        Open options menu
                                                                    </span>
                                                                    <EllipsisVerticalIcon
                                                                        className="h-5 w-5"
                                                                        aria-hidden="true"
                                                                    />
                                                                </Menu.Button>
                                                                <Transition
                                                                    as={Fragment}
                                                                    enter="transition ease-out duration-100"
                                                                    enterFrom="transform opacity-0 scale-95"
                                                                    enterTo="transform opacity-100 scale-100"
                                                                    leave="transition ease-in duration-75"
                                                                    leaveFrom="transform opacity-100 scale-100"
                                                                    leaveTo="transform opacity-0 scale-95"
                                                                >
                                                                    <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                                                        <div className="py-1">
                                                                            <Menu.Item>
                                                                                {({ active }) => (
                                                                                    <a
                                                                                        href="#"
                                                                                        className={classNames(
                                                                                            active
                                                                                                ? 'bg-gray-100 text-gray-900'
                                                                                                : 'text-gray-700',
                                                                                            'block px-4 py-2 text-sm'
                                                                                        )}
                                                                                    >
                                                                                        View profile
                                                                                    </a>
                                                                                )}
                                                                            </Menu.Item>
                                                                            <Menu.Item>
                                                                                {({ active }) => (
                                                                                    <a
                                                                                        href="#"
                                                                                        className={classNames(
                                                                                            active
                                                                                                ? 'bg-gray-100 text-gray-900'
                                                                                                : 'text-gray-700',
                                                                                            'block px-4 py-2 text-sm'
                                                                                        )}
                                                                                    >
                                                                                        Copy profile link
                                                                                    </a>
                                                                                )}
                                                                            </Menu.Item>
                                                                        </div>
                                                                    </Menu.Items>
                                                                </Transition>
                                                            </Menu>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="px-4 pt-5 pb-5 sm:px-0 sm:pt-0">
                                        <dl className="space-y-8 px-4 sm:space-y-6 sm:px-6">
                                            <div>
                                                <dt className="text-sm font-medium text-gray-500 sm:w-40 sm:flex-shrink-0">
                                                    Bio
                                                </dt>
                                                <dd className="mt-1 text-sm text-gray-900 sm:col-span-2">
                                                    <p>
                                                        Enim feugiat ut ipsum, neque ut. Tristique mi
                                                        id elementum praesent. Gravida in tempus
                                                        feugiat netus enim aliquet a, quam
                                                        scelerisque. Dictumst in convallis nec in
                                                        bibendum aenean arcu.
                                                    </p>
                                                </dd>
                                            </div>
                                            <div>
                                                <dt className="text-sm font-medium text-gray-500 sm:w-40 sm:flex-shrink-0">
                                                    Location
                                                </dt>
                                                <dd className="mt-1 text-sm text-gray-900 sm:col-span-2">
                                                    New York, NY, USA
                                                </dd>
                                            </div>
                                            <div>
                                                <dt className="text-sm font-medium text-gray-500 sm:w-40 sm:flex-shrink-0">
                                                    Website
                                                </dt>
                                                <dd className="mt-1 text-sm text-gray-900 sm:col-span-2">
                                                    ashleyporter.com
                                                </dd>
                                            </div>
                                            <div>
                                                <dt className="text-sm font-medium text-gray-500 sm:w-40 sm:flex-shrink-0">
                                                    Birthday
                                                </dt>
                                                <dd className="mt-1 text-sm text-gray-900 sm:col-span-2">
                                                    <time dateTime="1988-06-23">June 23, 1988</time>
                                                </dd>
                                            </div>
                                        </dl>
                                    </div>
                                </div>
                            </div>
                        </Dialog.Panel>
                    </Transition.Child>
                </div>
            </div>
        </div>
    </Dialog>
</Transition.Root>   */
};
